import Result from '@/lib/Result';
import { FaqService, FaqContent } from './services';
import { ContentResponse } from '@/types/ContentResponse';
import ApiClient from '@/lib/ApiClient';

export default class FaqApiService implements FaqService {
  public constructor(private readonly apiClient: ApiClient, private readonly stringHTMLBuilder: any) {}

  public async getFAQContent(cookieString?: string): Promise<FaqContent> {
    try {
      const res = await this.apiClient.get('/content/pages/pyramyd_faq', {
        headers: cookieString ? { Cookie: cookieString } : undefined,
      });
      const json: ContentResponse<string> = await res.json();

      if (json) {
        const totalRetail = await this.apiClient.get('/content/promotion-timers/FreeSHTotalRetail');
        const { data: FreeSHTotalRetail } = await totalRetail.json();

        const smartPostTotalRetail = await this.apiClient.get('/content/promotion-timers/FREESmartPostTotalRetail');
        const { data: FREESmartPostTotalRetail } = await smartPostTotalRetail.json();

        // Build string HTML
        const stringHTMLBuilder = new this.stringHTMLBuilder(json.content);
        stringHTMLBuilder.setDynamicData([
          { pointer: 'FreePost', value: FreeSHTotalRetail?.content.toString() },
          { pointer: 'FreeData', value: FREESmartPostTotalRetail?.content.toString() },
        ]);

        const stringFAQContent = stringHTMLBuilder.getStringHTML();

        return {
          content: stringFAQContent,
          timestamp: new Date().toLocaleString('en-US', {
            timeZone: 'America/New_York',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }),
        };
      }

      return {
        content: '',
        timestamp: new Date().toLocaleString('en-US', {
          timeZone: 'America/New_York',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }),
      };
    } catch (error) {
      throw new Error(`can't get faq page content ${error as string}`);
    }
  }

  public async getFAQEditUrl(): Promise<Result<string>> {
    try {
      const res = await this.apiClient.get('/content/pages/pyramyd_faq/edit-url');
      const json: ContentResponse<string> = await res.json();

      return new Result(json.content);
    } catch (error) {
      return new Result('');
    }
  }
}
